import { QueryHookOptions, useQuery } from "@apollo/client";
import { CountryCode, TransactionStatus, TransactionType, WalletPayoutStatus, WalletType } from "_graphql/__generated__/globalTypes";
import { GetSupplierWallets, GetSupplierWalletsVariables } from "_graphql/queries/__generated__/GetSupplierWallets";
import { GetTransactions, GetTransactionsVariables } from "_graphql/queries/__generated__/GetTransactions";
import { GetWalletPayouts, GetWalletPayoutsVariables } from "_graphql/queries/__generated__/GetWalletPayouts";
import { GetSupplierWalletWithdrawals, GetSupplierWalletWithdrawalsVariables } from "_graphql/queries/__generated__/GetSupplierWalletWithdrawals";
import { GetWalletPayoutsPendingCount, GetWalletPayoutsPendingCountVariables } from "_graphql/queries/__generated__/GetWalletPayoutsPendingCount";
import { getPayoutTransactions, getSupplierWalletWithdrawals, getSupplierWallets, getTransactions, getWalletPayoutsPendingCount } from "_graphql/queries/wallet";
// import { getPayoutTransactions, getTransactions, getWallet, getWalletHistory, getWalletSummary } from "_graphql/queries/wallet";


// export const useWallet = (
//     options?: QueryHookOptions<Wallet, WalletVariables>
// ) => {
//     const { data, ...rest } = useQuery<Wallet, WalletVariables>(
//         getWallet,
//         options
//     );

//     return {
//         wallet: data?.wallet,
//         ...rest,
//     };
// }
// export const useWalletSummary = (
//     options?: QueryHookOptions<GetSupplierWalletSummary, GetSupplierWalletSummaryVariables>
// ) => {
//     const { data, ...rest } = useQuery<GetSupplierWalletSummary, GetSupplierWalletSummaryVariables>(
//         getWalletSummary,
//         options
//     );

//     return {
//         wallet: data?.getSupplierWalletSummary,
//         ...rest,
//     };
// }
export const usePayoutRequests = (
    options?: QueryHookOptions<GetWalletPayouts, GetWalletPayoutsVariables>
) => {
    const { data, ...rest } = useQuery<GetWalletPayouts, GetWalletPayoutsVariables>(
        getPayoutTransactions,
        options
    );

    return {
        payouts: data?.getWalletPayouts || [],
        count: 120,
        ...rest,
    };
}


// export const useWalletHistory = (
//     options?: QueryHookOptions<WalletHistory, WalletHistoryVariables>
// ) => {
//     const { data, ...rest } = useQuery<WalletHistory, WalletHistoryVariables>(
//         getWalletHistory,
//         options
//     );

//     return {
//         history: data?.walletHistory || [],
//         count: data?.walletHistoryLength || 0,
//         ...rest,
//     };
// }

export const useSupplierWallets = (variables?: GetSupplierWalletsVariables) => {
    const { data, ...rest } = useQuery<GetSupplierWallets, GetSupplierWalletsVariables>(getSupplierWallets, {
        variables,
        skip: !variables?.userId,
    })

    return {
        wallets: data?.getSupplierWallets || [],
        ...rest
    }
}

export const usePendingPayoutRequestsCount = (walletId: string | undefined) => {
    const { data, ...rest } = useQuery<
        GetWalletPayoutsPendingCount,
        GetWalletPayoutsPendingCountVariables
    >(getWalletPayoutsPendingCount, {
        variables: {
            input: {
                filter: {
                    wallet_id: walletId ? { eq: walletId } : undefined,
                    status: { eq: WalletPayoutStatus.pending },
                    country: { eq: CountryCode.GH },
                },
            },
        },
        skip: !walletId,
        fetchPolicy: "cache-and-network",
    });

    return {
        pendingPayoutRequestsCount: data?.getWalletPayoutsCount ?? 0,
        ...rest,
    };
};

const WITHDRAWAL_TRANSACTIONS_PAGE_LIMIT = 5000;

export const useTotalWithdrawalsAmount = (walletId: string | undefined) => {
    const { data, ...rest } = useQuery<
        GetSupplierWalletWithdrawals,
        GetSupplierWalletWithdrawalsVariables
    >(getSupplierWalletWithdrawals, {
        variables: {
            input: {
                filter: {
                    wallet_type: { eq: WalletType.supplier },
                    wallet_id: { eq: walletId as string },
                    type: { eq: TransactionType.withdrawal },
                },
                pagination: { limit: WITHDRAWAL_TRANSACTIONS_PAGE_LIMIT, offset: 0 },
            },
        },
        skip: !walletId,
        fetchPolicy: "cache-and-network",
    });

    const rows = data?.getTransactions ?? [];
    const totalWithdrawals = rows
        .filter((t) => t?.status === TransactionStatus.success)
        .reduce((sum, t) => sum + Math.abs(t?.amount ?? 0), 0);

    return {
        totalWithdrawals,
        ...rest,
    };
};

export const useWalletTransactions = (variables?: GetSupplierWalletsVariables) => {
    const { data: walletData } = useQuery<GetSupplierWallets, GetSupplierWalletsVariables>(getSupplierWallets, {
        variables,
        skip: !variables?.userId,
    })
    const walletId = walletData?.getSupplierWallets?.find((w) => !w?.currency.code.startsWith('p'))?.id ?? null;
    const { data, ...rest } = useQuery<GetTransactions, GetTransactionsVariables>(getTransactions, {
        variables: {
            input: {
                filter: {
                    wallet_type: {
                        eq: WalletType.supplier
                    },
                    wallet_id: {
                        eq: walletId as string
                    }
                }
            }
        },
        skip: !walletData?.getSupplierWallets?.length

    })

    return {
        transactions: data?.getTransactions || [],
        ...rest
    }
}